"use client";

import { Compass } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function Capabilities() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const quote = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const divider = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const disciplines = [{
    number: "01",
    title: "Advanced Material Synthesis",
    description: "Precision engineering at the molecular level. From high-performance polymer bonding to structural composite integration, our processes are refined for industrial excellence.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/material_synthesis.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/material_synthesis.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/material_synthesis.webp-wvc-sizes",
    alt: "Close-up of industrial material testing and chemical synthesis equipment",
    span: "lg:col-span-5",
    height: "lg:h-[520px]",
    offset: ""
  }, {
    number: "02",
    title: "Custom Fabrication Solutions",
    description: "Tailored manufacturing for unique specifications. Every component is meticulously designed, tested, and calibrated to meet the most demanding operational requirements.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/custom_fabrication.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/custom_fabrication.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/custom_fabrication.png-wvc-sizes",
    alt: "Precision arrangement of custom fabricated industrial components",
    span: "lg:col-span-4",
    height: "lg:h-[420px]",
    offset: "lg:mt-24"
  }, {
    number: "03",
    title: "Structural Integrity Analysis",
    description: "The foundation of reliability. Rigorous stress testing, thermal analysis, and durability protocols ensure peak performance under extreme environmental conditions.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/structural_analysis.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/structural_analysis.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/structural_analysis.png-wvc-sizes",
    alt: "Industrial testing equipment prepared for structural stress analysis",
    span: "lg:col-span-3",
    height: "lg:h-[580px]",
    offset: ""
  }];
  return;
}